var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWriteFilled = function SvgWriteFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m10.542 5.225 4.233 4.233-7.05 7.05c-.158.159-.35.259-.567.3l-3.425.684a1.014 1.014 0 0 1-.942-.283c-.25-.25-.358-.6-.283-.942l.684-3.425c.041-.217.15-.409.3-.567l7.05-7.05Zm6.658.333L14.442 2.8c-.2-.2-.459-.308-.734-.308-.275 0-.541.108-.741.308l-1.542 1.542 4.233 4.233L17.2 7.033a1.041 1.041 0 0 0 0-1.475Z",
    fill: "current"
  })));
};
export default SvgWriteFilled;